export default {
  formError:
    'There are some errors in this form. Please correct them and try again.',
  loginError: 'Incorrect username or password.',
  emailError: 'Email address must conform to standard email format.',
  phoneFormatError: 'Phone number must be a standard 10-digit phone number.',
}
